import React from 'react'


interface Iprops{
    title?:any
}
export default function UrlTitle(props:Iprops) {
    return (
        <div className="url-title-div">  
            <h2 className="url-title">{props.title}</h2>   
        </div>
    )
}
